<!--
 * @Author: xiaokun
 * @Date: 2020-04-15 11:52:14
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-18 10:23:59
 * @Description: 搜索时间日期器
 -->
<template>
  <div class="approve-date-time-picker">
    <!-- 搜索时间日期器 -->
    <mk-date-picker
      v-model="curDateTime"
      type="datetimerange"
      range-separator="~"
      value-format="yyyy-MM-dd HH:mm:ss"
      format="yyyy-MM-dd HH:mm:ss"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      @change="selectDateTime"
    />
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  model: {
    event: 'change', prop: 'dateTime'
  },
  props: {
    dateTime: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      curDateTime: this.dateTime
    }
  },
  watch: {
    dateTime (val) {
      this.curDateTime = val
    }
  },
  methods: {
    selectDateTime (val) {
      this.$emit('change', val)
    }
  }
}
</script>
<style scoped lang="scss">
.approve-date-time-picker {
  margin-top: 1px;
}
</style>
